import { createEntityAdapter } from '@reduxjs/toolkit';
import { IEppType } from 'application/components/api/EppType';

export const eppTypeAdapter = createEntityAdapter<IEppType, number>({
  selectId: (project) => project.eppTypeID,
});
